import { useIntl } from 'react-intl';
import { Alert, Typography } from '@evaneos/b2b-ui';

import { NotFoundError } from '../../../resources/shared/api/client';

type TripProjectErrorAlertProps = {
    error: Error;
};

export const TripProjectErrorAlert = ({ error }: TripProjectErrorAlertProps) => {
    const { formatMessage } = useIntl();

    const messageId =
        error instanceof NotFoundError
            ? 'dossier.information.initial_request.no_longer_available'
            : 'dossier.information.initial_request.error';

    return (
        <Alert severity="error">
            <Typography variant="body2" sx={{ color: 'inherit' }}>
                {formatMessage({ id: messageId })}
            </Typography>
        </Alert>
    );
};
